import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectSignUpSubscriptions } from 'state/selectors/signUpSelectors';
import { I18N } from 'commons';
import SubscriptionInput from './SubscriptionInput';
import './SubscriptionContent.scss';

const SubscriptionContent = ({
  subscriptions, setAlertData, handleConfirmWindowShow,countRoot,
  nodisturb: { startTime, endTime, timeZoneId, startMeridiem, endMeridiem, wheatherChecked },
  handleWheatherTimeChange, handleIsShowSkipBtn, showAlertSubscriptionTimeZone, isInLoggedInEditProfileMode
}) => (
  <div>
    {
      isInLoggedInEditProfileMode ? 
      <h2 className="graybg h2-logged-in">
        <I18N>ssp.main.alertSubscriptions</I18N>
      </h2>:
      <h3 className="graybg">
        <I18N>ssp.main.alertSubscriptions</I18N>
      </h3>
    }
    <ul className="tree root-level">
      {subscriptions.map((subscription, index) => {
        let categorySelectedNum = 0;
        let categoryMandatoryNum = 0;
        subscription.nodes.forEach((category) => {
          if (category.leaf) {
            category.checked && categorySelectedNum++;
            category.mandatory && categoryMandatoryNum++;
            category.disabled = category.mandatory && category.checked;
            if (category.mandatory) {
              handleIsShowSkipBtn(false);
              // showSkipBtn = false;
            }
          } else {
            let leafSelectedNum = 0;
            let leafMandatoryNum = 0;
            category.nodes.forEach((leaf) => {
              leaf.checked && leafSelectedNum++;
              if (leaf.mandatory) {
                leafMandatoryNum++;
                handleIsShowSkipBtn(false);
                // showSkipBtn = false;
              }
              leaf.disabled = leaf.mandatory && leaf.checked;
            });
            category.checked = leafSelectedNum === category.nodes.length;
            category.checked && categorySelectedNum++;
            category.disabled = leafMandatoryNum === category.nodes.length;
            category.mandatory && category.disabled && categoryMandatoryNum++;
          }
        });
        subscription.checked = categorySelectedNum === subscription.nodes.length;
        subscription.disabled = categoryMandatoryNum === subscription.nodes.length;
        subscription.level = 'one';
        return (
          <li className="tree-parent" key={subscription.serviceId}>
            <SubscriptionInput
              selfIndex={index}
              key={subscription.serviceId}
              passToPrevLevel={countRoot}
              subscription={subscription}
              setAlertData={setAlertData}
              isRootElement
              wheatherChecked={wheatherChecked}
              handleConfirmWindowShow={handleConfirmWindowShow}
              startTime={startTime}
              startMeridiem={startMeridiem}
              endTime={endTime}
              endMeridiem={endMeridiem}
              timeZoneId={timeZoneId}
              handleWheatherTimeChange={handleWheatherTimeChange}
              showAlertSubscriptionTimeZone={showAlertSubscriptionTimeZone}
            />
          </li>
        );
      })}
    </ul>
  </div>
);

SubscriptionContent.propTypes = {
  subscriptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setAlertData: PropTypes.func.isRequired,
  nodisturb: PropTypes.shape().isRequired,
  handleConfirmWindowShow: PropTypes.func.isRequired,
  handleWheatherTimeChange: PropTypes.func.isRequired,
  handleIsShowSkipBtn: PropTypes.func.isRequired,
  showAlertSubscriptionTimeZone: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  subscriptions: selectSignUpSubscriptions(state),
});

export default connect(mapStateToProps)(SubscriptionContent);
